import { css } from '@emotion/react'

import Grid from './Grid'
import Text from './Text'

export default function OrderItem(props: {
  title: React.ReactNode
  subtitle?: React.ReactNode
  price: React.ReactNode
  stale?: boolean
  'data-testid'?: string
}) {
  return (
    <Grid
      spacing={5}
      css={css`
        margin-top: 10px;
        margin-bottom: 5px;
      `}
      data-testid={props['data-testid']}
    >
      <Grid.Row>
        <Grid spacing={10}>
          <Grid.Col flex>
            <Grid spacing={5}>
              <Grid.Row>
                <Text bold>{props.title}</Text>
              </Grid.Row>

              <Grid.Row>
                {props.subtitle && (
                  <Text size={12} color="Gray400">
                    {props.subtitle}
                  </Text>
                )}
              </Grid.Row>
            </Grid>
          </Grid.Col>

          <Grid.Col>
            <Text bold color={props.stale ? 'Gray300' : undefined}>
              {props.price}
            </Text>
          </Grid.Col>
        </Grid>
      </Grid.Row>
    </Grid>
  )
}
